export default __webpack_public_path__ + "images/35cbae94025ee4571ea0cc573c7aac41-hinduism.jpg";